import auth from '@/utils/authentication';
import { useEffect, useMemo, useState } from 'react';
export const routes = [{
  name: 'menu.dashboard',
  key: 'dashboard'
}, {
  name: 'menu.channel',
  key: 'channel',
  requiredPermissions: [{
    resource: 'channel',
    actions: ['*']
  }],
  children: [{
    name: 'menu.channel.list',
    key: 'channel/list'
  }, {
    name: 'menu.channel.product-admin',
    key: 'channel/product-admin'
  }, {
    name: 'menu.channel.product-list',
    key: 'channel/product-list'
  }]
}, {
  name: 'menu.agent',
  key: 'agent',
  requiredPermissions: [{
    resource: 'agent',
    actions: ['*']
  }],
  children: [{
    name: 'menu.agent.admin',
    key: 'agent/admin',
    requiredPermissions: [{
      resource: 'add-agent',
      actions: ['*']
    }]
  }, {
    name: 'menu.agent.list',
    key: 'agent/list'
  }, {
    name: 'menu.agent.channel-agent-set',
    key: 'agent/cnl-agent-set',
    requiredPermissions: [{
      resource: 'add-cnl-agent-set',
      actions: ['*']
    }]
  }, {
    name: 'menu.agent.channel-agent-set-list',
    key: 'agent/cnl-agent-set-list'
  }]
}, {
  name: 'menu.merchant0',
  key: 'merchant0',
  requiredPermissions: [{
    resource: 'merchant0',
    actions: ['*']
  }],
  children: [{
    name: 'menu.merchant.join',
    key: 'merchant/join',
    requiredPermissions: [{
      resource: 'add-merchant',
      actions: ['*']
    }]
  }, {
    name: 'menu.merchant.join-supply',
    key: 'merchant/join-supply',
    requiredPermissions: [{
      resource: 'add-merchant-supply',
      actions: ['*']
    }]
  }, {
    name: 'menu.merchant.income',
    key: 'merchant/income'
  }, {
    name: 'merchant.protocol',
    key: 'merchant/protocol/protocol'
  }, {
    name: 'merchant.withdraw-member-card',
    key: 'merchant/withdraw-member-card'
  }, {
    name: 'menu.merchant.list',
    key: 'merchant/list'
  }, {
    name: 'menu.merchant.mch-agent-set-list',
    key: 'merchant/mch-agent-set-list'
  }, {
    name: 'menu.merchant.instead-pay',
    key: 'merchant/instead-pay',
    requiredPermissions: [{
      resource: 'instead',
      actions: ['*']
    }]
  }, {
    name: 'merchant.virtual-account-detail',
    key: 'merchant/virtual-account-detail'
  }]
}, {
  name: 'menu.chart',
  key: 'chart',
  requiredPermissions: [{
    resource: 'chart',
    actions: ['*']
  }],
  children: [{
    name: 'chart.main-chart',
    key: 'chart/main-chart'
  }, {
    name: 'chart.scatter',
    key: 'chart/scatter'
  }, {
    name: 'chart.open-mch',
    key: 'chart/open-mch'
  }, {
    name: 'chart.performance-rank',
    key: 'chart/performance-rank'
  }, {
    name: 'chart.e-commerce-share',
    key: 'chart/e-commerce-share'
  }]
}, {
  name: 'menu.merchant',
  key: 'merchant',
  requiredPermissions: [{
    resource: 'merchant',
    actions: ['*']
  }],
  children: [{
    name: 'merchant.withdraw-member',
    key: 'merchant/withdraw-member',
    requiredPermissions: [{
      resource: 'personMch',
      actions: ['*']
    }]
  }, {
    name: 'merchant.withdraw-member-list',
    key: 'merchant/withdraw-member-list',
    requiredPermissions: [{
      resource: 'personMch',
      actions: ['*']
    }]
  }, {
    name: 'merchant.withdraw-member-card',
    key: 'merchant/withdraw-member-card'
  }, {
    name: 'menu.merchant.withdraw',
    key: 'merchant/withdraw',
    requiredPermissions: [{
      resource: 'withdraw',
      actions: ['*']
    }]
  }, {
    name: 'menu.merchant.instead-pay',
    key: 'merchant/instead-pay',
    requiredPermissions: [{
      resource: 'instead',
      actions: ['*']
    }]
  }, {
    name: 'menu.merchant.fund-transfer',
    key: 'merchant/fund-transfer/fundTransfer',
    requiredPermissions: [{
      resource: 'transfer',
      actions: ['*']
    }]
  }, {
    name: 'merchant.virtual-account-detail',
    key: 'merchant/virtual-account-detail'
  }]
}, {
  name: 'menu.sales-agent',
  key: 'sales-agent',
  requiredPermissions: [{
    resource: 'sales-agent',
    actions: ['*']
  }],
  children: [{
    name: 'menu.salesagent.list',
    key: 'salesagent/list'
  }, {
    name: 'menu.salesagent.instead-supply',
    key: 'salesagent/instead-supply',
    requiredPermissions: [{
      resource: 'instead-supply',
      actions: ['*']
    }]
  }, {
    name: 'menu.salesagent.withdraw-supply',
    key: 'salesagent/withdraw-supply',
    requiredPermissions: [{
      resource: 'withdraw-supply',
      actions: ['*']
    }]
  }]
}, {
  name: 'menu.settlement',
  key: 'settlement',
  requiredPermissions: [{
    resource: 'settlement',
    actions: ['list']
  }],
  children: [{
    name: 'menu.settlement.admin',
    key: 'settlement/admin/admin',
    requiredPermissions: [{
      resource: 'settlement',
      actions: ['admin']
    }]
  }, {
    name: 'menu.settlement.list',
    key: 'settlement/list/list'
  }]
}, {
  name: 'menu.adv',
  key: 'adv',
  requiredPermissions: [{
    resource: 'adv',
    actions: ['*']
  }],
  children: [{
    name: 'menu.adv.admin',
    key: 'adv/adv-admin',
    requiredPermissions: [{
      resource: 'adv',
      actions: ['admin']
    }]
  }, {
    name: 'menu.adv.clues',
    key: 'adv/clues'
  }, {
    name: 'menu.adv.connect',
    key: 'adv/adv-connect'
  }]
}, {
  name: 'menu.account-admin',
  key: 'account/admin'
}, {
  name: 'menu.risk',
  key: 'risk',
  requiredPermissions: [{
    resource: 'risk',
    actions: ['*']
  }],
  children: [{
    name: 'menu.risk.review',
    key: 'risk/review'
  }]
}, {
  name: 'menu.setting',
  key: 'setting',
  requiredPermissions: [{
    resource: 'set',
    actions: ['*']
  }],
  children: [{
    name: 'menu.setting.dash',
    key: 'setting/dash',
    children: [{
      name: 'menu.setting.dash.channel',
      key: 'setting/dash/channel'
    }, {
      name: 'menu.setting.dash.e-commerce',
      key: 'setting/dash/e-commerce'
    }, {
      name: 'menu.setting.dash.sms',
      key: 'setting/dash/sms'
    }, {
      name: 'menu.setting.dash.idp2',
      key: 'setting/dash/adminIdp2'
    }]
  }, {
    name: 'menu.setting.agent',
    key: 'setting/agent/agent',
    children: [{
      name: 'menu.setting.agent.mch_switch',
      key: 'setting/agent/mch_switch'
    }, {
      name: 'menu.setting.agent.mch_input',
      key: 'setting/agent/mch_input'
    }]
  }]
}];
export const getName = (path, routes) => {
  return routes.find(item => {
    const itemPath = `/${item.key}`;

    if (path === itemPath) {
      return item.name;
    } else if (item.children) {
      return getName(path, item.children);
    }
  });
};
export const generatePermission = role => {
  const actions = role === 'admin' ? ['*'] : ['read'];
  const result = {};
  routes.forEach(item => {
    if (item.children) {
      item.children.forEach(child => {
        result[child.name] = actions;
      });
    }
  });
  return result;
};

const useRoute = userPermission => {
  const filterRoute = (routes, arr = []) => {
    if (!routes.length) {
      return [];
    }

    for (const route of routes) {
      const {
        requiredPermissions,
        oneOfPerm
      } = route;
      let visible = true;

      if (requiredPermissions) {
        visible = auth({
          requiredPermissions,
          oneOfPerm
        }, userPermission);
      }

      if (!visible) {
        continue;
      }

      if (route.children && route.children.length) {
        const newRoute = { ...route,
          children: []
        };
        filterRoute(route.children, newRoute.children);

        if (newRoute.children.length) {
          arr.push(newRoute);
        }
      } else {
        arr.push({ ...route
        });
      }
    }

    return arr;
  };

  const [permissionRoute, setPermissionRoute] = useState(routes);
  useEffect(() => {
    const newRoutes = filterRoute(routes);
    setPermissionRoute(newRoutes);
  }, [JSON.stringify(userPermission)]);
  const defaultRoute = useMemo(() => {
    const first = permissionRoute[0];

    if (first) {
      const firstRoute = first?.children?.[0]?.key || first.key;
      return firstRoute;
    }

    return '';
  }, [permissionRoute]);
  return [permissionRoute, defaultRoute];
};

export default useRoute;